import { Component,HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss', './card-header.component.en.scss']
})
export class CardHeaderComponent {
  @Input({ required: true }) title!: string;
  @Input() icon!: string;
  @HostBinding('class.outside') @Input() outside: boolean = false;
}
